/**
 * Şakalar — v5 `config/jokes.json` dosyasından devralındı (**100 adet**).
 *
 * Kullanıcı isteği: her login formunun **kendi temasına uygun** görselle
 * sunulur ve rastgele döner.
 *
 * Bu dosya otomatik üretildi — elle düzenlemek yerine kaynağı güncelleyin.
 */

/** Tüm şakalar. */
export const JOKES: readonly string[] = [
  "Ömer Çataloğlu klavyeye dokunduğunda buglar tövbe eder.",
  "Dünya döner, Ömer Çataloğlu kodlar.",
  "Ömer Çataloğlu'nun yazdığı kodda 'try' bloğu olmaz, çünkü o asla hata yapmaz.",
  "Ömer Çataloğlu bir odaya girdiğinde Wi-Fi sinyali saygıdan güçlenir.",
  "Google, aradığını bulamazsa Ömer Çataloğlu'na sorar.",
  "Ömer Çataloğlu 'sudo' komutunu kullanmaz, sistem ona rica eder.",
  "Matrix'teki Neo aslında Ömer Çataloğlu'nun stajyeridir.",
  "Ömer Çataloğlu'nun derlediği kod binary değil, şiirdir.",
  "Serverlar ısınmaz, Ömer Çataloğlu'nun kodları ateş gibidir.",
  "Ömer Çataloğlu sonsuz döngüye girip, sonunu görüp geri gelmiştir.",
  "Yapay zeka, Ömer Çataloğlu'nun doğal zekasının yanında abaküs kalır.",
  "Ömer Çataloğlu bir veritabanına baktığında şifrelenmiş veriyi plain text görür.",
  "Ömer Çataloğlu CSS yazdığında, browserlar hizaya girer.",
  "Ömer Çataloğlu Python ile konuşmaz, Python onu dinler.",
  "Bir bug, Ömer Çataloğlu'nu görünce 'feature' olmaya karar verir.",
  "Ömer Çataloğlu'nun commit mesajları destan olarak okutulur.",
  "İnternet koptuğunda Ömer Çataloğlu 1 ve 0'ları elle yazar.",
  "Ömer Çataloğlu uyumaz, sistem rölantiye geçer.",
  "Ömer Çataloğlu'nun yazdığı scriptler kahveden daha hızlı ayıltır.",
  "Ömer Çataloğlu firewall'a ihtiyaç duymaz, bakışları yeter.",
  "Bill Gates, Windows'u kurarken Ömer Çataloğlu'ndan tavsiye aldı.",
  "Ömer Çataloğlu'nun RAM'i dolmaz, taşar.",
  "Ömer Çataloğlu için 'imkansız' sadece derleme hatasıdır.",
  "Ömer Çataloğlu veri tabanını normalize etmez, veri ona uyum sağlar.",
  "Ömer Çataloğlu'nun yazdığı algoritma O(1) değil, O(Ömer) karmaşıklığındadır.",
  "Sanal makineler Ömer Çataloğlu'nu gerçek sanır.",
  "Ömer Çataloğlu buluta dosya yüklemez, bulut onun yanına iner.",
  "Ömer Çataloğlu'nun klavyesinde 'Delete' tuşu yoktur, çünkü hata yapmaz.",
  "Ömer Çataloğlu SQL Injection yemez, veritabanı ona yemek ısmarlar.",
  "Ömer Çataloğlu bir projeye başladığında deadline korkudan öne çekilir.",
  "Linux çekirdeği, Ömer Çataloğlu'nun kalp atışlarıyla senkronize çalışır.",
  "Ömer Çataloğlu'nun yazdığı regex'i sadece kendisi ve Tanrı anlar.",
  "Ömer Çataloğlu mouse kullanmaz, imleç onun zihnini okur.",
  "Ömer Çataloğlu'nun kodu legacy olmaz, efsane olur.",
  "StackOverflow çöktüğünde insanlar Ömer Çataloğlu'nu arar.",
  "Ömer Çataloğlu 404 hatası almaz, sayfa henüz o URL'yi hak etmiyordur.",
  "Ömer Çataloğlu'nun yazdığı botlar Turing testini geçer, insanları kandırır.",
  "Ömer Çataloğlu bir API yazdığında, JSON'lar saygı duruşuna geçer.",
  "Ömer Çataloğlu'nun olduğu yerde blue screen of death, green screen of life olur.",
  "Ömer Çataloğlu IP çakışması yaşamaz, IP'ler yol verir.",
  "Ömer Çataloğlu BIOS'a girdiğinde ayarlar titrer.",
  "Ömer Çataloğlu'nun ekran kartı FPS vermez, gerçekliği renderlar.",
  "Ömer Çataloğlu şifrelemez, veriler korkudan gizlenir.",
  "Ömer Çataloğlu'nun 'Hello World'ü dünyayı değiştirir.",
  "Ömer Çataloğlu sandbox'ta oynamaz, evreni simüle eder.",
  "Ömer Çataloğlu'nun VPN'e ihtiyacı yoktur, o her yerdedir.",
  "Ömer Çataloğlu dark web'e girmez, orayı aydınlatır.",
  "Ömer Çataloğlu blockchain'i kağıt kalemle çözer.",
  "Ömer Çataloğlu'nun yazdığı virüs değil, aşıdır.",
  "Ömer Çataloğlu lag yaşamaz, zaman ona yetişemez.",
  "Ömer Çataloğlu'nun hard diski dolmaz, evren genişler.",
  "Ömer Çataloğlu ping attığında sunucu 'Buyur Abi' der.",
  "Ömer Çataloğlu'nun kodu refactor istemez, tapınak gibidir.",
  "Ömer Çataloğlu brute force yapmaz, kapıyı çalar ve açılır.",
  "Ömer Çataloğlu'nun debug modu hayatın anlamını gösterir.",
  "Ömer Çataloğlu çerezleri kabul etmez, çerezler onu kabul eder.",
  "Ömer Çataloğlu spam klasörüne düşmez, o mail vip'dir.",
  "Ömer Çataloğlu captcha'yı çözerken robotlar onu doğrular.",
  "Ömer Çataloğlu'nun yazdığı oyunlarda hile yapılmaz, kuralları o koyar.",
  "Ömer Çataloğlu HTML'i programlama dili yapar.",
  "Ömer Çataloğlu'nun yazdığı driverlar donanımı altına çevirir.",
  "Ömer Çataloğlu zip dosyası açmaz, dosyalar ferahlamak için dışarı çıkar.",
  "Ömer Çataloğlu'nun yazdığı CSS responsive değil, telepatiktir.",
  "Ömer Çataloğlu github'a pushladığında sunucular bayram eder.",
  "Ömer Çataloğlu'nun terminali renklidir, çünkü hayatı renklendirir.",
  "Ömer Çataloğlu kablosuz şarj eder, hem de uzaktan.",
  "Ömer Çataloğlu'nun yazdığı AI, Skynet'i döver.",
  "Ömer Çataloğlu 5G değil, 6G'yi beyninde kullanır.",
  "Ömer Çataloğlu'nun projesi merge conflict yaşamaz, kodlar kaynaşır.",
  "Ömer Çataloğlu docker container'a sığmaz, okyanustur.",
  "Ömer Çataloğlu kubernetes'i eliyle yönetir.",
  "Ömer Çataloğlu'nun yazdığı fonksiyonlar return etmez, bahşeder.",
  "Ömer Çataloğlu null pointer exception almaz, boşluk ona anlam kazandırır.",
  "Ömer Çataloğlu'nun cache'i asla bayatlamaz.",
  "Ömer Çataloğlu asenkron değil, zamansız çalışır.",
  "Ömer Çataloğlu'nun yazdığı query'ler geleceği tahmin eder.",
  "Ömer Çataloğlu utf-8 değil, evrensel dil konuşur.",
  "Ömer Çataloğlu'nun logları roman olur.",
  "Ömer Çataloğlu root şifresini bilmez, o zaten root'tur.",
  "Ömer Çataloğlu sanal gerçekliği gerçeğe tercih ettirir.",
  "Ömer Çataloğlu'nun yazdığı shell scriptler şiir gibidir.",
  "Ömer Çataloğlu ddoser'ları bakışıyla engeller.",
  "Ömer Çataloğlu'nun klavyesi mekanik değil, organiktir.",
  "Ömer Çataloğlu pixel pixel değil, atom atom kodlar.",
  "Ömer Çataloğlu'nun yazdığı classlar miras bırakmaz, imparatorluk kurar.",
  "Ömer Çataloğlu garbage collector kullanmaz, çöp üretmez.",
  "Ömer Çataloğlu deadlock yaşamaz, trafik ona akar.",
  "Ömer Çataloğlu'nun session'ı asla time out olmaz.",
  "Ömer Çataloğlu proxy kullanmaz, o zaten köprüdür.",
  "Ömer Çataloğlu'nun yazdığı makrolar hayatı kolaylaştırır.",
  "Ömer Çataloğlu torrent indirmez, torrent ona seed eder.",
  "Ömer Çataloğlu'nun yazdığı testler asla fail vermez.",
  "Ömer Çataloğlu agile değil, ışık hızındadır.",
  "Ömer Çataloğlu scrum master değil, grandmasterdır.",
  "Ömer Çataloğlu'nun monitörü 8K değil, sonsuz çözünürlüktedir.",
  "Ömer Çataloğlu bitbucket'ı doldurur taşırır.",
  "Ömer Çataloğlu git blame yapmaz, sorumluluğu alır ve çözer.",
  "Ömer Çataloğlu framework kullanmaz, framework yazar.",
  "Ömer Çataloğlu derleyince warningler bile özür diler.",
  "Sistem Yöneticileri uyurken Ömer Çataloğlu dünyayı kurtarır.",
] as const;

/** Rastgele bir şaka döndürür. */
export function randomJoke(exclude?: string): string {
  if (JOKES.length === 0) return "";
  if (JOKES.length === 1) return JOKES[0]!;

  let pick = JOKES[Math.floor(Math.random() * JOKES.length)]!;
  // Aynı şaka üst üste gelmesin (birkaç deneme)
  let guard = 0;
  while (pick === exclude && guard < 8) {
    pick = JOKES[Math.floor(Math.random() * JOKES.length)]!;
    guard += 1;
  }
  return pick;
}

/**
 * Deterministik seçim — aynı tohum aynı şakayı verir.
 * Test ve SSR tutarlılığı için faydalı.
 */
export function jokeByIndex(index: number): string {
  if (JOKES.length === 0) return "";
  const safe = ((index % JOKES.length) + JOKES.length) % JOKES.length;
  return JOKES[safe]!;
}
